<template>
  <div class="letter-display"
    v-if="getPersons()"
  >
    <h5>{{ letter }}</h5>
    <hr>
    <div class="listing-container">
      <div
        v-for="(person, index) in getPersons()"
        :key="`person-${index}`"
        class="person-listing clickable"
        @click="setAlbumPage(person)"
      >
        {{ person.firstName }} <strong>{{ person.lastName }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'letter-display',
  props: {
    letter: String
  },
  methods: {
    ...mapActions({
      setAlbumPage: 'setAlbumPage'
    }),
    getPersons () {
      return this.album.filter(e => e.lastName[0].toLowerCase() === this.letter.toLowerCase()).length > 0
        ? this.album.filter(e => e.lastName[0].toLowerCase() === this.letter.toLowerCase())
        : undefined
    }
  },
  computed: {
    ...mapGetters({
      album: 'album'
    })
  }
}
</script>

<style lang="scss" scoped>
.listing-container {
  margin: 1rem 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.clickable {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partials/Letter-display.vue